<template>
  <div class="section-container">
    <el-tabs class="tabs-container" v-model="activeTab" @tab-click="handleTabClick">
      <!-- 地图管理 Tab -->
      <el-tab-pane
        class="tab-pane"
        :label="$t('smartRouting.mapCenter.mapManagement.title')"
        name="map"
      >
        <MapList
          ref="mapListRef"
          :request="getStatistics"
          @add-map="handleAddMap"
          @view-detail="handleViewMapDetail"
        />
      </el-tab-pane>

      <!-- 路径规划 Tab -->
      <el-tab-pane
        class="tab-pane"
        :label="$t('smartRouting.mapCenter.pathPlanning.title')"
        name="route"
      >
        <RouteList
          ref="routeListRef"
          :request="getRouteList"
          @add-route="handleAddRoute"
          @deliver-route="handleDeliverRoute"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";
import { reactive, toRefs } from "@vue/reactivity";
// import Table from "@/components/elp/table";
import { useI18n } from "vue-i18n";
import MapList from "./components/mapList.vue";
import RouteList from "./components/routeList.vue";

export default {
  components: {
    MapList,
    RouteList
  },
  mixins: [common],
  setup() {
    const { t } = useI18n();
    const state = reactive({
      activeTab: "map",
      statisticsRef: null,
      statistics: {
        params: [
          {
            key: "userName",
            value: "",
            label: t("activity.points.name"),
          },
          {
            key: "userPhone",
            value: "",
            label: t("activity.packetjoin.phone"),
          },
        ],
      },
      detailRef: null,
      detail: {
        params: [
          {
            key: "userName",
            value: "",
            label: t("activity.points.name"),
          },
          {
            key: "userPhone",
            value: "",
            label: t("activity.packetjoin.phone"),
          },
          {
            key: "recommendUserName",
            value: "",
            label: t("activity.signup.referrer"),
          },
          {
            key: "recommendPhoneNumber",
            value: "",
            label: t("points.referrer.referrerPhoneNumber"),
          },
          {
            type: "Date",
            key: "dateRange",
            value: [],
            label: t("points.referrer.registrationTime"),
            options: {
              type: "datetimerange",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "range-separator": t("activity.detail.to"),
              "start-placeholder": t("activity.list.startDate"),
              "end-placeholder": t("activity.list.endDate"),
              "default-time": [
                new Date(2000, 1, 1, 0, 0, 0),
                new Date(2000, 1, 1, 23, 59, 59),
              ],
            },
          },
        ],
      },
    });

    const handleTabClick = () => {};

    // ========== API 请求方法 ==========
    const getStatistics = (params = {}) => {
      return request("getRecScoreList", params);
    };

    const getRouteList = (params = {}) => {
      return request("getRecScoreList", params);
    };

    const getDetail = (params = {}) => {
      const query = { ...params };
      if (params.dateRange?.length) {
        query.leftTime = params.dateRange[0];
        query.rightTime = params.dateRange[1];
      } else {
        query.leftTime = undefined;
        query.rightTime = undefined;
      }
      return request("getRecUserList", query);
    };

    const checkDetail = (row) => {
      state.activeTab = "detail";
      state.detailRef?.clearData();
      state.detailRef?.search({ userId: row.userId, recommendUserName: row.userName });
    };

    const exportData = async (params = {}) => {
      try {
        const query = { ...params };
        query.page = undefined;
        query.size = undefined;
        if (params.dateRange?.length) {
          query.leftTime = params.dateRange[0];
          query.rightTime = params.dateRange[1];
        } else {
          query.leftTime = undefined;
          query.rightTime = undefined;
        }
        const res = await downloadFile(
          "exportRecUserList",
          {},
          {
            method: "GET",
            params: query,
          }
        );
        const reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement("a");
          a.download = t("points.referrer.recommendationDetailsXlsx");
          a.href = e.target.result;
          a.click();
        };
      } catch (error) {
        console.error(error);
      }
    };

    // ========== 事件处理 ==========
    const handleAddMap = () => {
      console.log("新建地图");
    };

    const handleViewMapDetail = (row) => {
      console.log("查看地图详情", row);
    };

    const handleAddRoute = () => {
      console.log("新建路线");
    };

    const handleDeliverRoute = (row) => {
      console.log("下发路线", row);
    };

    return {
      ...toRefs(state),
      handleTabClick,
      getStatistics,
      getRouteList,
      getDetail,
      checkDetail,
      exportData,
      handleAddMap,
      handleViewMapDetail,
      handleAddRoute,
      handleDeliverRoute
    };
  },
};
</script>

<style scoped>
.section-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.list-item {
  margin-bottom: 0;
  text-align: left;
}
.tabs-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 100;
}
:deep(.tabs-container .el-tabs__content) {
  flex: 1;
}

:deep(.tabs-container .el-tabs__header) {
  padding: 24px 24px 0px 24px;
}

.tabs-container .tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>